import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { SubSink } from 'subsink';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { Router } from '@angular/router';
import { ChartType, ChartOptions } from 'chart.js';
import { Location } from '@angular/common';
import { Label } from 'ng2-charts';
import { ShowCampaignMessageComponent, ShowMessage } from '../../reports/cumulative-campaign-statistics/individual-campaign-statistics/show-campaign-message/show-campaign-message.component';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'campaign-statistic',
  templateUrl: './campaign-statistic.component.html',
  styleUrls: ['./campaign-statistic.component.css']
})

export class CampaignStatisticComponent implements OnInit, OnDestroy {
  private camapignId: number;
  private statistics: CampaignStatistic = new CampaignStatistic();
  private dataTable: any;
  private dtTable: any;
  private pieChartData: number[] = [];
  private pieChartLabels: Label[] = ['Not sent', 'Sent', 'Errors', 'Recieved'];
  private pieChartType: ChartType = 'pie';
  private pieChartLegend: boolean = true;
  private pieChartColors = [
    {
      backgroundColor: ['rgba(255,0,0,0.5)',
        'rgba(0,255,0,0.5)', 'rgba(0,0,255,0.5)',
        'rgba(255,255,0,0.5)'],
    },
  ];
  private pieChartOprions: ChartOptions = {
    responsive: true
  };

  @ViewChild('showMsgModal', { static: false }) showMsgModal: ShowCampaignMessageComponent;

  private isLoaded: boolean = false;
  private subs = new SubSink();

  constructor(private repository: HttpRepositoryService, private router: Router, private location: Location) { }

  ngOnInit() {
    this.dataTable = $('#msgOutBoxStat');
    this.loadData();
  }

  private loadData() {
    if (history.state.data == undefined) {
      this.router.navigateByUrl('/notfound');
    } else {
      this.camapignId = history.state.data.id;

      this.subs.sink = this.repository.get<CampaignStatistic>('api/Campaign/Statistic?campaignId=' + this.camapignId).subscribe(resp => {
        if (resp.hasErrors) {
          Toast.Show(resp.error, 'Campaign statistics', 'error');
        } else {
          this.statistics = resp.data;

          this.pieChartData = [];
          this.pieChartData.push(this.statistics.messageSum - (this.statistics.sentMsgSum + this.statistics.sendErrorSum));
          this.pieChartData.push(this.statistics.sentMsgSum);
          this.pieChartData.push(this.statistics.sendErrorSum);
          this.pieChartData.push(this.statistics.recievedMsgSum);
          this.isLoaded = true;

          this.createDataTable();
        }
      });
    }
  }

  private createDataTable() {
    let that = this;

    var dtOptions = {
      data: this.statistics.outboxes,
      columns: [
        {
          name: 'id',
          visible: false
        },
        {
          name: 'recepient'
        },
        {
          name: 'numberOfMessages',
          class: 'text-center',
          filterable: false,
        },
        {
          name: 'isSent',
          class: 'text-center',
          filterable: false,
          width: '70px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          useFalseIcon: true
        },
        {
          name: 'isError',
          class: 'text-center',
          filterable: false,
          width: '70px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          useFalseIcon: true
        },
        {
          name: 'failedCount',
          class: 'text-center',
          filterable: false
        },
        {
          name: 'errorReason',
          class: 'text-center',
          filterable: false
        },
        {
          name: 'isDelivered',
          class: 'text-center',
          filterable: false,
          width: '70px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          useFalseIcon: true
        },
        {
          name: 'deliveryTime',
          class: 'text-center',
          filterable: false
        },
        {
          name: 'numberOfLinks',
          class: 'text-center',
          filterable: false
        },
        {
          name: 'numberOfClickedLinks',
          class: 'text-center',
          filterable: false
        }
      ],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [{
          text: '<i class="far fa-envelope-open"></i> Show message',
          class: 'messagerow',
          dataAttributes: ['id'],
          action: function () {
            
          }
        }]
      }
    }

    this.dataTable.off('click', '.messagerow');

    this.dataTable.on('click', '.messagerow', function () {
      let id = parseInt($(this)[0].dataset.customId);
      that.showMsg(id, that.statistics.outboxes);
    });

    if (this.dtTable)
      this.dtTable.Destroy();

    this.dtTable = this.dataTable.LinkTable(dtOptions);
  
  }

  private showMsg(id: number, data: MsgOutBoxStatistics[]) {
    let showMessage = new ShowMessage();
    let message = data.find(x => x.id === id);

    if (message) {
      showMessage.id = message.id;
      showMessage.recepient = message.recepient;
      showMessage.content = message.body;

      this.showMsgModal.show(showMessage);
    }
  }

  private goBack() {
    this.location.back();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    this.pieChartData = [];
    this.isLoaded = false;

    if (this.dtTable)
      this.dtTable.Destroy();
  }
}

export class CampaignStatistic {
  id: number;
  name: string;
  startSendTime: string;
  sentMsgSum: number;
  messageSum: number;
  sendErrorSum: number;
  recievedMsgSum: number;
  linkSumPerMsg: number;
  sumOfClickedLinksPerPhoneNum: number;
  outboxes: MsgOutBoxStatistics[];
}

export class MsgOutBoxStatistics {
  id: number;
  idCampaign: number;
  recepient: string;
  body: string;
  numberOfMessages: number;
  isSent: boolean;
  failedCount: number;
  isRecieved: boolean;
  numberOfLinks: number;
  numberOfClickedLinks: number;
  isError: boolean;
  errorReason: string;
  isDelivered: boolean;
  DeliveryTime: string;
}
